import React from "react";
import { Card } from "@mui/material";

import { ProfileTabConfig } from "../../Profile/types/profileTypes";
import StoreDetailsTab from "../tabs/StoreDetailsTab";
import StoreEmployeesTab from "../tabs/StoreEmployeesTab";
import StoreCustomersTab from "../tabs/StoreCustomersTab";
import StoreSuppliersTab from "../tabs/StoreSuppliersTab";
import { useResponsive } from "@kivunova/kivufrontendcommon";

const TabCard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { spacing } = useResponsive();
  return (
    <Card
      sx={{
        borderRadius: 3,
        p: spacing.p,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
      }}
    >
      {children}
    </Card>
  );
};

export const StoreTabsConfig = (storeId: string): ProfileTabConfig[] => {
  return [
    {
      id: 0,
      labelKey: "store-details-tab",
      defaultLabel: "Details",
      ariaControls: "store-details-tabpanel-0",
      content: (
        <TabCard>
          <StoreDetailsTab storeId={storeId} />
        </TabCard>
      )
    },
    {
      id: 1,
      labelKey: "store-employees-tab",
      defaultLabel: "Employees",
      ariaControls: "store-employees-tabpanel-1",
      content: (
        <TabCard>
          <StoreEmployeesTab storeId={storeId} />
        </TabCard>
      )
    },
    {
      id: 2,
      labelKey: "store-customers-tab",
      defaultLabel: "Customers",
      ariaControls: "store-customers-tabpanel-2",
      content: (
        <TabCard>
          <StoreCustomersTab storeId={storeId} />
        </TabCard>
      )
    },
    {
      id: 3,
      labelKey: "store-suppliers-tab",
      defaultLabel: "Suppliers",
      ariaControls: "store-suppliers-tabpanel-3",
      content: (
        <TabCard>
          <StoreSuppliersTab storeId={storeId} />
        </TabCard>
      )
    }
  ];
};
